import React, { useMemo } from 'react';

import { cn } from '@/shared/lib/tailwind-merge';
import { Text } from '@/shared/ui';

type SummaryRowProps = {
    label: string;
    value?: string;
    children?: React.ReactNode;
    className?: string;
};

export const SummaryRow = ({ label, value, children, className }: SummaryRowProps) => {
    const { labelId, valueId } = useMemo(() => {
        let labelId = '';
        let valueId = '';

        if (label) {
            labelId = label.toLowerCase().replace(/ /g, '-');
            labelId += '-label';

            valueId = label.toLowerCase().replace(/ /g, '-');
            valueId += '-value';
        }

        return { labelId, valueId };
    }, [label]);

    return (
        <div
            className={cn(
                'flex justify-between items-center py-2 h-[48px] border-b border-border-opaque',
                className,
            )}
        >
            <Text type={Text.types.Paragraph} fontWeight={Text.weights.SemiBold} name={labelId}>
                {label}
            </Text>
            <div className='flex items-center gap-[6px] text-md'>
                <Text type={Text.types.Paragraph} fontWeight={Text.weights.SemiBold} name={valueId}>
                    {value}
                </Text>
                {children}
            </div>
        </div>
    );
};

export default SummaryRow;
